import { IsString } from "class-validator";

export class Maid {
  @IsString()
  readonly id: string;

  @IsString()
  readonly label: string;

  constructor(init?: Maid) {
    this.id = init?.id!;
    this.label = init?.label!;
  }
}

export default Maid;
